import { render, staticRenderFns } from "./MmScrollablePopup.vue?vue&type=template&id=5b69c4c5&scoped=true"
import script from "./MmScrollablePopup.vue?vue&type=script&lang=ts"
export * from "./MmScrollablePopup.vue?vue&type=script&lang=ts"
import style0 from "./MmScrollablePopup.vue?vue&type=style&index=0&id=5b69c4c5&prod&scoped=true&lang=css"
import style1 from "./MmScrollablePopup.vue?vue&type=style&index=1&id=5b69c4c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b69c4c5",
  null
  
)

export default component.exports